import { useSelector, useDispatch } from "react-redux"

import { limsReviews } from "state_management"
import useT from "utils/hooks/useT"
import { UnplannedProjectActionItem } from "./index"

// Reviews section of the right panel's Project tab (PRD-003 Area 1 / SPEC-007; extended in
// SPEC-011 to also carry CORRECTION tasks). Lists the UNPLANNED QC-task actions as a prioritised
// inbox, oldest first, directly below "Standard Actions" and above "Unplanned Projects".
//
// SPEC-011: the inbox is filtered to the CURRENT viewer's role — a reviewer sees kind:"review"
// tasks ("Review <analysis>"); the analyst sees kind:"correction" tasks assigned back to them
// ("Correct <analysis>") when a reviewer returned their results. Each task reuses the existing
// UnplannedProjectActionItem card (already draggable as a single-action); clicking it opens the
// analysis the task covers on the plan instead of the default single-action "Edit Project" dialog.
// The whole section is gated on showLims by the caller; a card leaves the inbox once it is planned
// (selectOpenQcTasksForViewer drops it). The heading stays "Reviews".
export default function ReviewsSection() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const openTasks = useSelector(limsReviews.selectOpenQcTasksForViewer)
  const unplannedProjectActions = useSelector((state) => state.projectActions.unplannedProjectActions)
  // RR8 #4060: the card must carry the colour of the analysis task it was made from. Its own
  // single-action project has no colour set, which is why these rendered white next to the
  // dark-green analysis they belong to.
  const plannedAnalyses = useSelector((state) => state.analyses.plannedAnalyses)

  return (
    <div className="ProjectTasksMenu-tasks-container ReviewsSection">
      <div className="FilterButtons-Container">
        <h5 className="Pheading ActionList-Caption">{t("reviews")}</h5>
      </div>
      {openTasks.length === 0 ? (
        <p className="ReviewsSection-empty">{t("reviewsEmpty")}</p>
      ) : (
        openTasks.map((task) => {
          const action = unplannedProjectActions[task.actionId]
          if (!action) return null
          return (
            <UnplannedProjectActionItem
              key={task.id}
              action={action}
              colorOverride={(plannedAnalyses[task.analysisId] && plannedAnalyses[task.analysisId].color) || null}
              onClick={() => dispatch(limsReviews.openReviewAnalysis(task.analysisId))}
            />
          )
        })
      )}
      <hr />
    </div>
  )
}
